import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import ProtectedRoute from './components/ProtectedRoute'
import ProtectedERPRoute from './components/ProtectedERPRoute'
import SmartRedirect from './components/SmartRedirect'
import ErpEntryRedirect from './components/ErpEntryRedirect'
import { MODULES, ACTIONS } from './hooks/usePermissions'
import ERPRoutes from './pages/ERP/ERPRoutes'
import PedidosPage from './pages/ERP/Vendas/Pedidos/PedidosPage'
import VendasPage from './pages/ERP/Vendas/Vendas/VendasPage'
import PreVendaPage from './pages/ERP/Vendas/PreVenda/PreVendaPage'
import LoginPage from './pages/Login/LoginPage'
import OrganizationSignupPage from './pages/Login/OrganizationSignupPage'
import PlatformLoginPage from './pages/Platform/PlatformLoginPage'
import OrganizationsPage from './pages/Platform/OrganizationsPage'
import OrganizationFormPage from './pages/Platform/OrganizationFormPage'
import OrganizationManagePage from './pages/Platform/OrganizationManagePage'
import './App.css'

function AppContent() {
  const location = useLocation()
  const isERPRoute = location.pathname.startsWith('/erp')
  const isLoginRoute = location.pathname === '/login' || location.pathname.startsWith('/cadastro') || location.pathname.startsWith('/plataforma')
  const isPedidosRoute = location.pathname.startsWith('/pedidos')
  const isVendasRoute =
    location.pathname === '/erp/vendas/vendas' ||
    location.pathname === '/erp/vendas/pre-venda'
  const isTvDisplayRoute = location.pathname.includes('/erp/vendas/tv-display')

  return (
    <div className={`app ${isTvDisplayRoute ? 'tv-display-app' : ''}`}>
      <a href="#main-content" className="skip-link">
        Pular para o conteúdo principal
      </a>

      <main
        id="main-content"
        className={`main-content ${isERPRoute ? 'erp-route' : ''} ${
          isLoginRoute ? 'login-route' : ''
        } ${isPedidosRoute ? 'pedidos-route' : ''} ${isVendasRoute ? 'vendas-route' : ''} ${
          isTvDisplayRoute ? 'tv-display-route' : ''
        }`}
        role="main"
      >
        <Routes>
          <Route path="/" element={<ErpEntryRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cadastro/:token" element={<OrganizationSignupPage />} />
          <Route path="/plataforma/login" element={<PlatformLoginPage />} />
          <Route path="/plataforma/nova" element={<OrganizationFormPage />} />
          <Route path="/plataforma/:id" element={<OrganizationManagePage />} />
          <Route path="/plataforma" element={<OrganizationsPage />} />

          <Route path="/admin" element={<Navigate to="/erp/dashboard" replace />} />

          <Route
            path="/pedidos"
            element={
              <ProtectedRoute>
                <PedidosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/erp/vendas/vendas"
            element={
              <ProtectedRoute>
                <SmartRedirect
                  requiredModule={MODULES.SALES}
                  requiredAction={ACTIONS.SALES_PDV_VIEW}
                >
                  <VendasPage />
                </SmartRedirect>
              </ProtectedRoute>
            }
          />
          <Route
            path="/erp/vendas/pre-venda"
            element={
              <ProtectedRoute>
                <SmartRedirect
                  requiredModule={MODULES.SALES}
                  requiredAction={ACTIONS.SALES_PRESALE}
                >
                  <PreVendaPage />
                </SmartRedirect>
              </ProtectedRoute>
            }
          />
          <Route
            path="/erp/*"
            element={
              <ProtectedERPRoute>
                <ERPRoutes />
              </ProtectedERPRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  )
}

export default App
